import React from 'react';
import compose from 'recompose/compose';
import defaultProps from 'recompose/defaultProps';
import withPropsOnChange from 'recompose/withPropsOnChange';
import pure from 'recompose/pure';
import { Motion, spring } from 'react-motion';
import './ClusterMarker.css';

export const clusterMarker = ({text, lat, lng, defaultMotionStyle, motionStyle, zoom, setMapProps, isSelected, onPage}) => {
  const handleClick = () => {
    if (zoom < 14) {
      setMapProps({center: {lat, lng}, zoom: (zoom+1)})
    }
  }
  let classNames = ['cluster-marker'];
  if(onPage){
    classNames.push('cluster-page');
  }
  if(isSelected){
    classNames.push('cluster-selected');
  }

  return (
    <Motion
      defaultStyle={defaultMotionStyle}
      style={motionStyle}
    >
    {
      ({ scale }) => (
        <div
          className={classNames.join(' ')}
          style={{
            transform: `translate3D(0,0,0) scale(${scale}, ${scale})`,
          }}
          onClick = {handleClick}
        >
          <div>
            {text}
          </div>
        </div>
      )
    }
    </Motion>
  );
};

export const clusterMarkerHOC = compose(
  defaultProps({
    text: '0',
    initialScale: 0.6,
    defaultScale: 1,
    hoveredScale: 1.15,
    hovered: false,
    stiffness: 320,
    damping: 7,
    precision: 0.001,
  }),
  // pure optimization can cause some effects you don't want,
  // don't use it in development for markers
  pure,
  withPropsOnChange(
    ['initialScale'],
    ({ initialScale, defaultScale, $prerender }) => ({
      initialScale,
      defaultMotionStyle: { scale: $prerender ? defaultScale : initialScale },
    })
  ),
  withPropsOnChange(
    ['hovered'],
    ({
      hovered, hoveredScale, defaultScale,
      stiffness, damping, precision,
    }) => ({
      hovered,
      motionStyle: {
        scale: spring(
          hovered ? hoveredScale : defaultScale,
          { stiffness, damping, precision }
        ),
      },
    })
  )
);

export default clusterMarkerHOC(clusterMarker);